import { type ImgHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Avatar size variants.
 *
 * | size | px   | usage                         |
 * |------|------|-------------------------------|
 * | `sm` | 30px | Inline                        |
 * | `md` | 40px | Default avatar                |
 * | `lg` | 50px | Top bar                       |
 */
const avatarVariants = cva('rounded-full overflow-hidden flex-shrink-0 bg-border', {
  variants: {
    size: {
      sm: 'size-[30px]',
      md: 'size-10',
      lg: 'size-[50px]',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export type AvatarProps = ImgHTMLAttributes<HTMLImageElement> & VariantProps<typeof avatarVariants>;

export { avatarVariants };
